<div class="notif-bell-wrap" *ngIf="enabled">
    <!-- Bell button -->
    <button class="notif-bell-btn" (click)="togglePanel()" [class.has-unread]="unreadCount > 0" title="Notifications">
        <i class="pi pi-bell"></i>
        <span class="notif-badge" *ngIf="unreadCount > 0">{{ unreadCount > 99 ? '99+' : unreadCount }}</span>
    </button>

    <!-- Dropdown panel -->
    <div class="notif-panel" *ngIf="panelOpen">
        <div class="notif-panel-header">
            <span class="notif-panel-title">Notifications</span>
            <button class="notif-mark-all" (click)="markAllRead()" *ngIf="unreadCount > 0" title="Mark all as read">
                <i class="pi pi-check-circle"></i> Mark all read
            </button>
        </div>

        <div class="notif-list">
            <ng-container *ngIf="unreadCount > 0; else noNotif">
                <div class="notif-item unread" *ngFor="let n of notifications | unreadNotif; trackBy: trackById"
                     (click)="markOneRead(n)">
                    <div class="notif-dot"></div>
                    <div class="notif-content">
                        <div class="notif-title">{{ n.title }}</div>
                        <div class="notif-body">{{ n.body }}</div>
                        <div class="notif-time">{{ n.created_at | date:'d MMM, h:mm a' }}</div>
                    </div>
                </div>
            </ng-container>
            <ng-template #noNotif>
                <div class="notif-empty">
                    <i class="pi pi-bell-slash"></i>
                    <span>No notifications</span>
                </div>
            </ng-template>
        </div>
    </div>
</div>

